function formatTimeWithMeridiem (date: Date): string {
  const hour = date.getHours()
  const minute = date.getMinutes()
  const meridiem = hour >= 12 ? '오후' : '오전'
  const formattedHour = hour % 12 === 0 ? 12 : hour % 12
  const formattedMinute = minute.toString().padStart(2, '0')

  return `${meridiem} ${formattedHour}:${formattedMinute}`
}

function formatDate (date: Date): string {
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')

  return `${year}.${month}.${day}`
}

export function formatDateTime (dateTime: string): string {
  const targetDate = new Date(dateTime)
  const currentDate = new Date()
  const diffMinutes = Math.floor((currentDate.getTime() - targetDate.getTime()) / 60000)

  if (diffMinutes <= 59) {
    return `${diffMinutes}분 전`
  } else if (currentDate.getDate() === targetDate.getDate()) {
    return formatTimeWithMeridiem(targetDate)
  } else {
    return formatDate(targetDate)
  }
}
